module.exports = __webpack_public_path__ + "static/media/timer-pause.00992341.png";